import { useContext } from "react";
import { AppContext } from "../App";
import { LegalTexts } from "./LegalTexts";
import { t } from "../i18n";

export const PopupClientEdit = (props) => {
	const {
		FLOW,
		data,
		setData,
		popUpClientEdit,
		closePopUpClientEdit,
		errors,
		validateForm,
	} = useContext(AppContext);

	const updateData = () => {
		if (!validateForm()) {
			console.log("Formulario con errores, deteniendo navegación...");
			return;
		}

		let API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";

		let controller = new AbortController();
		let options = {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(data),
			signal: controller.signal,
		};

		fetch(`${API_URL}/bookings/${data.locator}`, options)
			.then((res) => res.json())
			.then((newData) => {
				// console.log(newData);
			})
			.catch((err) => {
				console.error(err);
			})
			.finally(() => {
				controller.abort();
			});

		closePopUpClientEdit();
	};

	return (
		<div
			className={
				"popup_client_edit kensei_02" +
				(popUpClientEdit ? " isActive" : "")
			}
		>
			<div className="popup_client_edit_content">
				<button
					onPointerDown={closePopUpClientEdit}
					className="popup_client_edit_close"
				>
					<img
						className="popup_client_edit_icon"
						src="resources/icons/close.svg"
						alt="Cerrar"
					/>
				</button>
				<div className="popup_client_edit_body">
					<h2>{t("Datos cliente")}</h2>
					<form>
						<label>
							<strong>{t("Nombre y Apellidos")}</strong>
							<input
								type="text"
								defaultValue={data ? data.name : ""}
								onChange={(e) =>
									setData({
										...data,
										name: e.target.value,
									})
								}
							/>
							{errors.name && (
								<span className="error">{errors.name}</span>
							)}
						</label>
						<label>
							<strong>{t("Teléfono")}</strong>
							<input
								type="tel"
								defaultValue={data ? data.phone : ""}
								onChange={(e) =>
									setData({
										...data,
										phone: e.target.value,
									})
								}
							/>
							{errors.phone && (
								<span className="error">{errors.phone}</span>
							)}
						</label>
						{FLOW === "mapfre" && (
							<label>
								<strong>{t("Email")}</strong>
								<input
									type="email"
									defaultValue={data ? data.email : ""}
									onChange={(e) =>
										setData({
											...data,
											email: e.target.value,
										})
									}
								/>
								{errors.email && (
									<span className="error">
										{errors.email}
									</span>
								)}
							</label>
						)}
					</form>
					<button
						onPointerDown={updateData}
						className={
							"nav_next" +
							(!data.name || !data.phone ? " disabled" : "")
						}
						href="/#"
					>
						<img
							className="footer_icon"
							src="resources/icons/update.svg"
							alt="Actualizar datos"
						/>
						<p className="footer_p">{t("Actualizar datos")}</p>
					</button>
					<LegalTexts />
				</div>
			</div>
		</div>
	);
};
